const translations = {
    message: 'Start your 7 day free trial.',
    startTrialNow: 'Start Trial Now!',
    subscribeMessage: 'Subscribe to Premier to unlock all features.',
    subscribeNow: 'Subscribe Now!'
};

export default translations;
